import { api } from '@/api/api'
import { IOrder } from '@/models'

export async function fetchOrderDefaultShippingAddress(orderCode: string): Promise<IOrder> {
    const {
        data: { shippingAddress, customer },
    } = await api.get(`order/defaultShippingAddress/${orderCode}`)

    return {
        orderCode,
        defaultShippingAddress: shippingAddress,
        defaultShippingContactData: {
            email: customer.mail,
            phoneNo: customer.phone,
        },
    }
}
